<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-input
          v-model="search"
          placeholder="Mavsum nomi bo'yicha qidirish"
          clearable
          class="header-control"
          @input="onSearch"
          @clear="onSearch"
        />

        <el-select
          v-model="startYear"
          class="header-year"
          placeholder="Yildan"
          clearable
          @change="onYearChange"
        >
          <el-option
            v-for="year in yearOptions"
            :key="`s-${year}`"
            :value="year"
            :label="year"
          />
        </el-select>

        <el-select
          v-model="endYear"
          class="header-year"
          placeholder="Yilgacha"
          clearable
          @change="onYearChange"
        >
          <el-option
            v-for="year in yearOptions"
            :key="`e-${year}`"
            :value="year"
            :label="year"
            :disabled="startYear && year < startYear"
          />
        </el-select>
      </div>
    </div>

    <el-table :data="boards" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column label="Nomi" min-width="260">
        <template #default="scope">
          {{ scope.row.title
          }}{{
            scope.row.season || scope.row.year
              ? ` (${scope.row.season ? scope.row.season + "-mavsum " : ""}${
                  scope.row.year || ""
                })`
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="Turi" min-width="140">
        <template #default="scope">
          {{ scope.row.type || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="Deputatlar" min-width="120" align="center">
        <template #default="scope">
          {{ scope.row.deputies_count || 0 }}
        </template>
      </el-table-column>
      <el-table-column label="Biriktirish oynasi" min-width="180">
        <template #default="scope">
          <el-tag :type="windowTagType(scope.row.window_status)">
            {{ windowLabel(scope.row.window_status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Muddat" min-width="220">
        <template #default="scope">
          {{ formatDate(scope.row.accept_start_date) }} —
          {{ formatDate(scope.row.deputy_end_date) }}
        </template>
      </el-table-column>
      <el-table-column width="160" label="Loyihalar ijrosi" fixed="right">
        <template #default="scope">
          <el-button
            size="small"
            type="primary"
            @click="goToFeed(scope.row)"
          >
            Ko'rish
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Kengashlar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "ChosenInitiativesBoards",
  data() {
    return {
      loading: false,
      boards: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: "",
      searchTimer: null,
      // Year filter — deputy v2 era starts at 2026; pre-2026 boards must NOT appear
      // unless the user explicitly clears the default.
      DEPUTY_V2_START_YEAR: 2026,
      startYear: 2026,
      endYear: null,
    };
  },
  computed: {
    yearOptions() {
      const current = new Date().getFullYear();
      const last = Math.max(current + 1, this.DEPUTY_V2_START_YEAR);
      const years = [];
      for (let year = last; year >= this.DEPUTY_V2_START_YEAR; year -= 1) {
        years.push(year);
      }
      return years;
    },
  },
  methods: {
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    formatDate(value) {
      return value ? this.$moment(value).format("DD-MM-YYYY") : "-";
    },
    windowLabel(status) {
      const map = {
        not_started: "Boshlanmagan",
        open: "Ochiq",
        closed: "Yopiq",
      };
      return map[status] || "-";
    },
    windowTagType(status) {
      const map = {
        not_started: "warning",
        open: "success",
        closed: "info",
      };
      return map[status] || "info";
    },
    getBoards() {
      this.loading = true;
      this.$http
        .get("api/v1/deputyv2/deputy-manager/boards", {
          params: {
            search: this.search || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
            start_year: this.startYear || null,
            end_year: this.endYear || null,
          },
        })
        .then(({ data }) => {
          this.boards = data.boards || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getBoards();
      }, 400);
    },
    onYearChange() {
      if (this.startYear && this.endYear && this.endYear < this.startYear) {
        this.endYear = null;
      }
      this.currentPage = 1;
      this.getBoards();
    },
    goToFeed(row) {
      this.$router.push({
        name: "BoardChosenInitiatives",
        params: { boardId: row.id },
        query: { title: row.title, year: row.year },
      });
    },
    handleCurrentChange() {
      this.getBoards();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getBoards();
    },
  },
  mounted() {
    this.getBoards();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 280px;
  flex-shrink: 0;
}

.header-year {
  width: 130px;
  flex-shrink: 0;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
